<template>
  <form class="validate-form" @submit.prevent="handleLogin">
    <h2 class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
      {{ $t('public.login') }}
    </h2>
    <div class="intro-x mt-8">
      <div class="mt-6">
        <label for="email" class="form-label w-full flex flex-col sm:flex-row">
          Email
        </label>
        <input
          id="email"
          v-model.trim="validate.email.$model"
          type="text"
          name="email"
          class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
          :class="{ 'border-theme-6': validate.email.$error }"
        />
        <template v-if="validate.email.$error">
          <div
            v-for="(error, index) in validate.email.$errors"
            :key="index"
            class="text-theme-6 mt-2"
          >
            {{ $t(error.$message) }}
          </div>
        </template>
      </div>
      <div class="mt-6">
        <label for="password" class="form-label w-full flex flex-col sm:flex-row">
          {{ $t('common.password') }}
        </label>
        <input
          id="password"
          v-model.trim="validate.password.$model"
          type="password"
          name="password"
          class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
          :class="{ 'border-theme-6': validate.password.$error }"
        />
        <template v-if="validate.password.$error">
          <div
            v-for="(error, index) in validate.password.$errors"
            :key="index"
            class="text-theme-6 mt-2"
          >
            {{ $t(error.$message) }}
          </div>
        </template>
      </div>
      <div class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4">
        <router-link :to="{ name: 'forgot-password' }" tag="a">
          {{ $t('public.forgotenPassword') }}
        </router-link>
      </div>
      <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
        <button
          class="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top"
          type="submit"
          v-if="!loading"
        >
          {{ $t('public.loginIn') }}
        </button>
        <div
          class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center"
          v-if="loading"
        >
          <LoadingIcon icon="three-dots" class="w-8 h-8" />
        </div>
      </div>
      <div class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4">
        <router-link :to="{ name: 'sign-up' }" tag="a">
          {{ $t('public.signUp') }}
        </router-link>
      </div>
    </div>
  </form>
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('public.loginFailed') }}!</div>
      <div class="text-gray-600 mt-1">{{ $t('form.checkLoginData') }}</div>
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, toRefs, reactive, ref } from 'vue'
import { required, helpers, email } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Toastify from 'toastify-js'

export default defineComponent({
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/')
    }
  },
  methods: {
    handleLogin(data) {
      this.loading = true

      this.validate.$touch()
      if (this.validate.$invalid) {
        this.loading = false
        return
      }

      this.$store
        .dispatch('auth/login', {
          email: data.target.elements.email.value,
          password: data.target.elements.password.value
        })
        .then(
          () => {
            this.$router.push('/choose-role')
          },
          (error) => {
            this.loading = false
            Toastify({
              node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
              duration: 10000,
              newWindow: true,
              close: true,
              gravity: 'top',
              position: 'right',
              stopOnFocus: true
            }).showToast()
            this.message =
              (error.response && error.response.data && error.response.data.message) ||
              error.message ||
              error.toString()
          }
        )
    }
  },
  setup() {
    const loading = ref(false)
    const formData = reactive({
      email: '',
      password: ''
    })
    const rules = {
      email: {
        required: helpers.withMessage('form.validation.requiredField', required),
        email: helpers.withMessage('form.validation.email', email)
      },
      password: {
        required: helpers.withMessage('form.validation.requiredField', required)
      }
    }
    const validate = useVuelidate(rules, toRefs(formData))

    return {
      loading,
      validate,
      formData
    }
  }
})
</script>
